<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'view_tag' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseViewTagComponentPanel()">
                    {{ 'label_close' | translate: param }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div *ngIf="inputData" class="block mt-2 padding-top-0">
                <div class="row margin-top-20">
                    <span *ngFor="let tag of inputData"
                        class="align-middle d-inline-block position-relative margin-right-5 disabled margin-top-5">
                        <button type="button"
                            class="text-logo-blue bg-light-grey border border-secondary rounded padding-5 align-middle">
                            {{tag}}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>